// src/components/manager/meetings/MeetingView.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { formatDateTime } from "../../../utils/dateUtils";

const MeetingView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [meeting, setMeeting] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_WEB_SERVICES_URL}/manager/get-meeting-by-id/${id}`, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status) setMeeting(res.data.meeting);
      })
      .catch(() => alert("Failed to fetch meeting details."));
  }, [id]);


    const renderNames = (arr) => {
    if (!arr || arr.length === 0) return "-";
    return arr.map(item => item.label).join(", ");
  };

  if (!meeting) return <div className="container-fluid p-4">Loading...</div>;

  return (
     <div className="container-fluid px-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">View Meeting</h3>
      </div>

      {meeting ?
       <div className="card shadow mt-4">
  <div className="card-header bg-light d-flex align-items-center">
    <i className="bi bi-calendar-event me-2 text-primary"></i>
    <h5 className="mb-0">{meeting.title}</h5>
  </div>
  <div className="card-body p-4">
    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-list-task me-2 text-secondary"></i>Agenda:</label>
      <div className="col-sm-9">{meeting.agenda || "-"}</div>
    </div>

    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-journal-text me-2 text-secondary"></i>Notes:</label>
      <div className="col-sm-9 border rounded p-2 bg-light">
        {meeting.notes ? (
          <span dangerouslySetInnerHTML={{ __html: meeting.notes }} />
        ) : (
          "-"
        )}
      </div>
    </div>

    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-clock me-2 text-secondary"></i>Date & Time:</label>
      <div className="col-sm-9">{formatDateTime(meeting.meeting_datetime)}</div>
    </div>

    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-link-45deg me-2 text-secondary"></i>Link:</label>
      <div className="col-sm-9">
        {meeting.meeting_link ? (
          <a href={meeting.meeting_link} target="_blank" rel="noreferrer">{meeting.meeting_link}</a>
        ) : (
          "-"
        )}
      </div>
    </div>

    <hr />

    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-building me-2 text-secondary"></i>Properties:</label>
      <div className="col-sm-9">{renderNames(meeting.property_ids)}</div>
    </div>

    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-people me-2 text-secondary"></i>Guests:</label>
      <div className="col-sm-9">{renderNames(meeting.guest_ids)}</div>
    </div>

    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-person-badge me-2 text-secondary"></i>Managers:</label>
      <div className="col-sm-9">{renderNames(meeting.manager_ids)}</div>
    </div>

    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-person-check me-2 text-secondary"></i>Assist. Managers:</label>
      <div className="col-sm-9">{renderNames(meeting.assistant_manager_ids)}</div>
    </div>

    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-eye me-2 text-secondary"></i>Overseers:</label>
      <div className="col-sm-9">{renderNames(meeting.overseer_ids)}</div>
    </div>

    <hr />

    <div className="mb-3 row">
      <label className="col-sm-3 fw-bold"><i className="bi bi-calendar-check me-2 text-secondary"></i>Created At:</label>
      <div className="col-sm-9">{formatDateTime(meeting.created_at)}</div>
    </div>

    <div className="text-end">
      <button className="btn btn-sm btn-secondary" onClick={() => navigate("/admin/meetings/list")} ><i className="bi bi-arrow-left-circle me-1"></i> Back</button>
    </div>
  </div>
</div>


:

 <div className="card shadow mt-4">
          <div className="card-body p-4">
           No Record Found.
          </div>

           </div>
   
      }

    </div>
  );
};

export default MeetingView;
